import React from 'react';
import { Button, ButtonProps, useTheme } from '@mui/material';
import { GamifyIcon } from 'application/components/GamifyIcon';

interface ShrinkButtonProps extends Omit<ButtonProps, 'children'> {
  disabled?: boolean;
  onClick?: () => void;
}

export default function ShrinkButton({
  disabled = false,
  onClick,
  sx,
  ...props
}: ShrinkButtonProps) {
  const theme = useTheme();

  return (
    <Button
      sx={[
        (theme) => ({
          backgroundColor: theme.custom?.background1,
          p: 1,
          borderRadius: '10px',
          minWidth: '32px',
          minHeight: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: `1px solid ${theme.custom?.stroke}`,
          color: theme.custom?.text,
          '&:hover': {
            backgroundColor: theme.custom?.background2,
          },
          '&:disabled': {
            backgroundColor: theme.custom?.background1,
            opacity: 0.5,
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      <GamifyIcon icon="shrink" color={theme.custom?.text} />
    </Button>
  );
}
